export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';
export const NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB = 'newbuilding_confident_booking_cardjk_web';
/** Акция «30 000 ₽ за покупку квартиры»: A — контроль, B — точки входа показаны (HBC-1800) */
export const NEWBUILDING_PURCHASE_GIFT_EXPERIMENT = 'newbuilding_benefits_on_apartments';
